import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Users from "../screens/auth/Users";
import Admin from "../screens/auth/Admin";

export const authRoutes = [
  {
    path: "/users",
    component: <Users />,
  },
  {
    path: "/admin",
    component: <Admin />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];